import isTruthy, { type Falsy } from './isTruthy';

export function filterTruthy<T>(x: T | Falsy): x is T {
    return isTruthy(x);
}
